import { Global } from '@emotion/react';

import type { JSX } from 'react';

export function Fonts(): JSX.Element {
  return (
    <Global
      styles={`
        @font-face {
          font-weight: 700;
          font-family: 'monoId';
          src: url('/fonts/Monoid-Bold.ttf') format('ttf');
        }
        @font-face {
          font-weight: 500;
          font-family: 'monoId';
          src: url('/fonts/Monoid-Retina.ttf') format('ttf');
        }
        @font-face {
          font-weight: 400;
          font-family: 'monoId';
          src: url('/fonts/Monoid-Italic.ttf') format('ttf');
        }
        @font-face {
          font-weight: 400;
          font-family: 'monoId';
          src: url('/fonts/Monoid-Regular.ttf') format('ttf');
        }
        @font-face {
          font-weight: 400;
          font-family: 'cassandra';
          src: url('/fonts/Cassandra-Regular.ttf') format('ttf');
        }
      `}
    />
  );
}
